<template>
<div >
  <div class="detailsTitle">
      <h4>
        打印
        <el-button type="primary" @click="dayinFN">打印</el-button>
        <el-button type="primary" @click="xieyiFN">打印运输协议</el-button>
      </h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <div id="printMe"  ref="print">
    <div  v-for="(val,index) in dataList" :key="index" style="page-break-after:always;">
      <div class="table_title" style="position: relative;">
          <p style="padding-top:10px">中物唐山曹妃甸物流有限公司</p>
          <p>运单</p>
          <div  style="position: absolute;top:-20px">
            <canvas id="barCode" ref="barCode" style="display: none;" ></canvas>
            <img :src="val.src" alt="" style="width:240px;height:auto" >
          </div>
      </div>
      <!-- <p>客户名称：{{val.goodform.payee}}</p> -->
      <table style="word-break:break-all;word-wrap:break-all;">
        <tr>
          <td class="td1">车牌号</td>
          <td class="td3">{{val.goodform.plateNumber}}</td>
          <td class="td1">司机姓名</td>
          <td class="td1">{{val.goodform.driverName}}</td>
          <td class="td1">司机手机号</td>
          <td class="td3">{{val.goodform.driverPhone}}</td>
        </tr>
        <tr>
          <td class="td1">要求到达时间</td>
          <td class="td3" colspan="2">{{val.goodform.arrivalTime|dateFormat1}}</td>
          <td class="td1">回单要求</td>
          <td class="td3" colspan="2">{{val.goodform.receiptRequest}}</td>
        </tr>
        <tr>
          <td  class="td1">备注</td>
          <td colspan="5">{{val.goodform.remark}}</td>
        </tr>
      </table>
      <div class="addressBox" style="margin-top:20px">
        <h4>
          <span>收发地址</span>
        </h4>
        <table style="word-break:break-all;word-wrap:break-all;">
          <tr>
            <td  class="td1">发货人</td>
            <td class="td1">{{val.goodform.deliverPerson}}</td>
            <td class="td1">发货电话</td>
            <td class="td1" style="width:220px">{{val.goodform.deliverPhone}}</td>
            <td class="td1">发货地址</td>
            <td class="td2">{{val.goodform.deliverAddress}}</td>
          </tr>
          <tr>
            <td  class="td1">收货人</td>
            <td class="td1">{{val.goodform.receivingPerson}}</td>
            <td class="td1">收货电话</td>
            <td class="td1" style="width:220px">{{val.goodform.receivingPhone}}</td>
            <td class="td1">收货地址</td>
            <td class="td2">{{val.goodform.receivingAddress}}</td>
          </tr>
        </table>
      </div>
      <div class="addressBox" style="margin-top:20px">
        <h4>
          <span>货物信息</span>
        </h4>
      <table style="word-break:break-all;word-wrap:break-all;" v-if="val.goodform.goodsYn==1">
          <tr>
            <td>序号</td>
            <td>捆包号</td>
            <td>货物类型</td>
            <td>材质</td>
            <td>规格</td>
            <td>重量(吨)</td>
            <td>数量(件)</td>
            <td>体积(方)</td>
            <td>合同号</td>
            <td>合约号</td>
            <td>货位</td>
          </tr>
          <tr v-for="(item, index) in val.ATableList" :key="index">
            <td >{{ index+1 }}</td>
            <td >{{ item.cargoBarcode }}</td>
            <td >{{ val.goodform.productTypeName }}</td>
            <td >{{ item.model }}</td>
            <td >{{ item.specification }}</td>
            <td >{{ item.weight?Number(item.weight).toFixed(3):'' }}</td>
            <td >{{ item.number}}</td>
            <td >{{ item.volumn?Number(item.volumn).toFixed(3):'' }}</td>
            <td >{{ item.contractNumber }}</td>
            <td >{{item.agreementNumber}}</td>
            <td >{{item.cargoLocation}}</td>
          </tr>
          <tr>
            <td colspan="5">合计</td>
            <td >{{val.allWeight?toFixed(val.allWeight,3):''}}</td>
            <td >{{val.allNumber?val.allNumber:''}}</td>
            <td >{{val.allVolumn?toFixed(val.allVolumn,3):''}}</td>
            <td ></td>
            <td ></td>
            <td ></td>
          </tr>
        </table>
        <table style="word-break:break-all;word-wrap:break-all;" v-else>
          <tr>
            <td>货物类型</td>
            <td v-if="val.goodform.dispatchWeight">重量(吨)</td>
            <td v-if="val.goodform.dispatchNumber">数量(件)</td>
            <td v-if="val.goodform.dispatchVolumn">体积(方)</td>
          </tr>
          <tr>
            <td >{{val.goodform.productTypeName}}</td>
            <td  v-if="val.goodform.dispatchWeight">{{val.goodform.dispatchWeight}}</td>
            <td  v-if="val.goodform.dispatchNumber">{{val.goodform.dispatchNumber}}</td>
            <td  v-if="val.goodform.dispatchVolumn">{{val.goodform.dispatchVolumn}}</td>
          </tr>
        </table>
      </div>
      <div class="AMarkFoot">
        <ul>
          <li>打印人:{{dayinren}}</li>
          <li>打印时间:{{timestamp|dateFormat}}</li>
        </ul>
      </div>
    </div>
  </div>
   <el-dialog title="打印运输协议" :visible.sync="xieyiMark" :close-on-click-modal="false" width="80%" center>
     <div>
        <el-button type="primary" @click="xieyidayinFN">打印</el-button>
      </div>
      <div  id="printMe1" ref="print1" >
       <div v-for="(val,index) in dataList" :key="index" style="page-break-after:always;">
      <!-- 打印 -->
        <div class="table_title">运输协议</div>
        <el-form :inline="true" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="150px" size="mini">
          <div class="inpBox">
            <el-form-item label="司机姓名:" >
              <span >{{val.goodform.driverName}}</span>
            </el-form-item>
            <el-form-item label="车牌号:" label-width="100px" >
              <span >{{val.goodform.plateNumber}}</span>
            </el-form-item>
            <el-form-item label="车辆类型:" >
              <span >{{val.goodform.vehicleTypeName}}</span>
            </el-form-item>
            <br>
            <el-form-item label="驾驶证号:" >
              <span>{{val.goodform.idNumber}}</span>
            </el-form-item>
            <el-form-item label="档案编号:" label-width="100px" >
              <span style="width:220px">{{val.goodform.wayNo}}</span>
            </el-form-item>
            <br>
            <el-form-item label="司机联系电话:" >
              <span>{{val.goodform.driverPhone}}</span>
            </el-form-item>
            <el-form-item label="委托期限:" label-width="100px" >
              <span style="width:200px">{{val.goodform.createTime|dateFormat}}-结算完成</span>
            </el-form-item>
            <br>
            <el-form-item label="承运人（司机）住址:" >
              <span></span>
            </el-form-item>
            <br>
            <el-form-item label="车属单位或车主:" >
              <span style="width:500px"></span>
            </el-form-item>
            <br>
            <el-form-item label="委托方地址/电话:" >
              <span style="width:500px">{{val.goodform.deliverPerson}}-{{val.goodform.deliverPhone}}-{{val.goodform.deliverAddress}}</span>
            </el-form-item>
            <br>

            <el-form-item label="收货方地址/电话:" >
              <span style="width:500px">{{val.goodform.receivingPerson}}-{{val.goodform.receivingPhone}}-{{val.goodform.receivingAddress}}</span>
            </el-form-item>
            <br>
            <el-form-item label="货物名称:" >
              <span>{{val.goodform.productTypeName}}</span>
            </el-form-item>
            <el-form-item label="共计运输:" >
              <span style="width:200px">{{val.goodform.dispatchWeight}}（吨）{{val.goodform.dispatchNumber}}（件）{{val.goodform.dispatchVolumn}}（方）</span>
            </el-form-item>
            <br>
            <el-form-item :label="'运输单价（元/'+val.goodform.measuringUnit+'）:'" >
              <span>{{val.goodform.freightUnitPrice?val.goodform.freightUnitPrice/100:'包干'}}</span>
            </el-form-item>
            <el-form-item label="运费合计（元）:" >
              <span>{{val.goodform.freightAmount/100}}</span>
            </el-form-item>
          </div>
          <h6>其他</h6>
          <p>1）货物交接后，由承运方负责送达目的地并承担丢失损坏造成的意外事故或未送达到目的地（迟送到目的地）的经济赔偿。（注：陶瓷洁具破损率为1.5%）</p>
          <p>2）运输途中过路、过桥、摆渡等一切费用由车主负责。</p>
          <p>3）承运方必须对托运方的运输货物交接手续，让收货方在回单上签字确认。如将随货单位丢失由此带来的一切损失由承运方承担</p>
          <p>4）运输车辆在装车前必须听从专业装车人员的安排，货物出厂前如提不出装车及货物是否损坏方面的异议（包括超重、超宽），视为承运方认可装车合格。如有异议请在第一时间通知：唐山曹妃甸兴瀚钢铁物流有限公司（汽运部调度室24小时电话：18931573605）。</p>
          <p>5）承运方对所承担的货物要采取保护措施，如彩涂卷、镀锌卷、加工配件等需加盖雨布、苫布，货物底部需垫草垫或三公分以上厚度皮带以固定货物防止运输过程中货物挤压、碰撞，因承运方个人疏忽导致货物受潮，磨损、挤压变形，损坏、丢失等造成的经济损失由承运方全部承担，并自损失之日起5日内处理完毕</p>
          <p>6）本合同一式两份，承运方，托运方各执一份</p>
          <el-form-item label="托运方（调度）签字:" >
            <span></span>
          </el-form-item>

          <el-form-item label=" 承运方（司机）签字:" >
            <span> </span>
          </el-form-item>
          <br>
          <span style="width:300px"> {{companyName}} </span>
          <div style="text-align: right;">
            <el-form-item label="" >
              <span>{{ timestamp|dateFormat }} </span>
            </el-form-item>
          </div>
        </el-form>
      </div>
      </div>
    </el-dialog>
</div>
</template>

<script>
import { printWayInfoList } from '@/api/newTMS'
import JsBarcode from 'jsbarcode'
import { toFixed } from '@/utils/util'
export default {
  data () {
    let ids = this.$route.query.ids
    return {
      toFixed: toFixed,
      bindBarCode (selector, data) {
        JsBarcode(selector, data, {
          format: 'CODE128', // 条形码的格式
          width: 2, // 设置条之间的宽度
          height: 50, // 高度
          fontSize: 19, // 设置文本的大小
          fontOptions: 'bold', // 使文字加粗体或变斜体
          displayValue: true, // 是否在条形码下方显示文字
          lineColor: '#000', // 线条颜色
          margin: 5// 设置条形码周围的空白区域
        })
      },
      getFlag: true,
      src: '',
      ids: ids.split(','),
      dataList: [],
      dayinren: '',
      timestamp: null,
      xieyiMark: false,
      addFrom: {},
      companyName: localStorage.getItem('companyName')
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.timestamp = new Date().getTime()
    printWayInfoList({ wayBusinessIds: this.ids }).then(res => {
      this.dataList = []
      res.forEach((item1, index) => {
        let json = {}
        json.goodform = item1.tWay
        json.ATableList = item1.goodslist
        json.allWeight = 0
        json.allNumber = 0
        json.allVolumn = 0
        item1.goodslist.forEach(item => {
          if (item.weight) {
            json.allWeight = (json.allWeight * 1000 + item.weight * 1000) / 1000
          }
          if (item.number) {
            json.allNumber = (json.allNumber * 1000 + item.number * 1000) / 1000
          }
          if (item.volumn) {
            json.allVolumn = (json.allVolumn * 1000 + item.volumn * 1000) / 1000
          }
        })
        for (var key in item1.tWayBusiness) {
          if (key != 'id') {
            json.goodform[key] = item1.tWayBusiness[key]
          }
        }
        this.$nextTick(() => {
          let canvas = this.$refs.barCode
          this.bindBarCode(canvas[index], json.goodform.wayNo)
          json.src = canvas[index].toDataURL('image/png')
          this.$forceUpdate()
        })
        this.dataList.push(json)
      })

      this.dayinren = localStorage.getItem('userName')
    })
  },
  methods: {
    xieyidayinFN () {
      this.$print(this.$refs.print1)
    },
    xieyiFN () {
      this.xieyiMark = true
    },
    dayinFN () {
      this.$print(this.$refs.print)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }

}
</script>

<style scoped lang='less'>
#printMe {
  font-size: 16px;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
}
table {
  border-collapse: collapse;
}
table,
th,
td {
  border: 1px solid #666;
}
table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  td {
    text-align: center;
    height: 30px;
  }
  .td1{
    width: 120px;
  }
  .td3{
    width:30%;
  }
  .td2{
    width:50%;
  }
}
.table_title p{
  text-align: center;
  font-size: 22px;
}
.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
    }
  }
}
#printMe1 {
  font-size: 14px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  .el-form-item span {
    display: inline-block;
    width: 150px;
  }
  .table_title {
    width: 100%;
    height: 40px;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
ul {
  width: 100%;
  display: flex;
  li {
    list-style: none;
    flex: 1;
    // color: black;
  }
}
</style>
